import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { PreviewItem } from 'Components/ComponentLibrary/Components/Uncategorized/FileViewer/components/PreviewItem';
import { useWidth } from 'Hooks/useDimensions';
import { NoAttachment } from './NoAttachment';

export const AttachmentViewer = () => {
  const { resource } = useMetaLayoutContext();
  const [parentRef, width] = useWidth();

  return (
    <div
      style={{
        width: '100%',
        position: 'relative',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        boxSizing: 'border-box',
      }}
      ref={parentRef}
    >
      <div style={{
        position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
      }}
      >
        {resource.withRelationship(fr.relationships.attachment.name, (rel) => (
          <PreviewItem
            presentsAsDownloadable={resource.withRelationship(fr.relationships.presentsAsDownloadable.name, () => true, () => false)}
            attachmentName={rel.meta('title')}
            attachmentHref={rel.link('related').url()}
            height={width * 2}
            width={width - 15}
            alignItem={'top'}
          />
        ), () => (<NoAttachment />))}
      </div>
    </div>
  );
};
